var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.26489C5 5.39489 8.13 2.26489 12 2.26489C15.87 2.26489 19 5.39489 19 9.26489C19 13.4349 14.58 19.1849 12.77 21.3749C12.37 21.8549 11.64 21.8549 11.24 21.3749C9.42 19.1849 5 13.4349 5 9.26489ZM9.5 9.26489C9.5 10.6449 10.62 11.7649 12 11.7649C13.38 11.7649 14.5 10.6449 14.5 9.26489C14.5 7.88489 13.38 6.76489 12 6.76489C10.62 6.76489 9.5 7.88489 9.5 9.26489Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.b050860d554f01aac5d9276beac53e16.svg";
export { ForwardRef as ReactComponent };